import type { StoredConnection } from "./schema";

const DB_VERSION = 1;
const STORE = "connections";

export function openDb(name = "streamvault-static"): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(name, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) {
        const store = db.createObjectStore(STORE, { keyPath: "id" });
        store.createIndex("lastUsedAt", "lastUsedAt");
        store.createIndex("providerType", "providerType");
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

function tx(db: IDBDatabase, mode: IDBTransactionMode): IDBObjectStore {
  return db.transaction(STORE, mode).objectStore(STORE);
}

function awaitRequest<T>(req: IDBRequest<T>): Promise<T> {
  return new Promise((resolve, reject) => {
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function putConnection(db: IDBDatabase, conn: StoredConnection): Promise<void> {
  const store = tx(db, "readwrite");
  await awaitRequest(store.put(conn));
}

export async function getConnection(db: IDBDatabase, id: string): Promise<StoredConnection | null> {
  const store = tx(db, "readonly");
  const result = await awaitRequest(store.get(id));
  return result ?? null;
}

export async function listConnections(db: IDBDatabase): Promise<StoredConnection[]> {
  const store = tx(db, "readonly");
  const all = await awaitRequest<StoredConnection[]>(store.getAll());
  return all.sort((a, b) => b.lastUsedAt - a.lastUsedAt);
}

export async function deleteConnection(db: IDBDatabase, id: string): Promise<void> {
  const store = tx(db, "readwrite");
  await awaitRequest(store.delete(id));
}
